export default __webpack_public_path__ + "static/media/entity-framework.283214e7.png";